export default __webpack_public_path__ + "static/media/ReFLeague1.79e1d5f9.svg";